// DESCRIPTION: Canonical currency list for the plugin. Single source of truth
// shared by the setup wizard, payment settings, and any future currency picker.

/**
 * Currencies we offer in admin pickers. Codes follow ISO 4217. Order is
 * roughly: G7 majors, then alphabetical by region. All codes here are
 * supported by Stripe; offline payments accept any of them.
 *
 * @since PBOOKING_SINCE
 */
export const CURRENCIES = [
	{ code: 'USD', name: 'US Dollar' },
	{ code: 'EUR', name: 'Euro' },
	{ code: 'GBP', name: 'British Pound' },
	{ code: 'CAD', name: 'Canadian Dollar' },
	{ code: 'AUD', name: 'Australian Dollar' },
	{ code: 'NZD', name: 'New Zealand Dollar' },
	{ code: 'JPY', name: 'Japanese Yen' },
	{ code: 'CNY', name: 'Chinese Yuan' },
	{ code: 'HKD', name: 'Hong Kong Dollar' },
	{ code: 'SGD', name: 'Singapore Dollar' },
	{ code: 'INR', name: 'Indian Rupee' },
	{ code: 'BDT', name: 'Bangladeshi Taka' },
	{ code: 'PKR', name: 'Pakistani Rupee' },
	{ code: 'LKR', name: 'Sri Lankan Rupee' },
	{ code: 'NPR', name: 'Nepalese Rupee' },
	{ code: 'IDR', name: 'Indonesian Rupiah' },
	{ code: 'MYR', name: 'Malaysian Ringgit' },
	{ code: 'PHP', name: 'Philippine Peso' },
	{ code: 'THB', name: 'Thai Baht' },
	{ code: 'VND', name: 'Vietnamese Dong' },
	{ code: 'KRW', name: 'South Korean Won' },
	{ code: 'TWD', name: 'New Taiwan Dollar' },
	{ code: 'AED', name: 'UAE Dirham' },
	{ code: 'SAR', name: 'Saudi Riyal' },
	{ code: 'QAR', name: 'Qatari Riyal' },
	{ code: 'KWD', name: 'Kuwaiti Dinar' },
	{ code: 'BHD', name: 'Bahraini Dinar' },
	{ code: 'OMR', name: 'Omani Rial' },
	{ code: 'ILS', name: 'Israeli Shekel' },
	{ code: 'TRY', name: 'Turkish Lira' },
	{ code: 'EGP', name: 'Egyptian Pound' },
	{ code: 'NGN', name: 'Nigerian Naira' },
	{ code: 'KES', name: 'Kenyan Shilling' },
	{ code: 'GHS', name: 'Ghanaian Cedi' },
	{ code: 'ZAR', name: 'South African Rand' },
	{ code: 'MAD', name: 'Moroccan Dirham' },
	{ code: 'CHF', name: 'Swiss Franc' },
	{ code: 'SEK', name: 'Swedish Krona' },
	{ code: 'NOK', name: 'Norwegian Krone' },
	{ code: 'DKK', name: 'Danish Krone' },
	{ code: 'ISK', name: 'Icelandic Krona' },
	{ code: 'PLN', name: 'Polish Zloty' },
	{ code: 'CZK', name: 'Czech Koruna' },
	{ code: 'HUF', name: 'Hungarian Forint' },
	{ code: 'RON', name: 'Romanian Leu' },
	{ code: 'BGN', name: 'Bulgarian Lev' },
	{ code: 'UAH', name: 'Ukrainian Hryvnia' },
	{ code: 'RUB', name: 'Russian Ruble' },
	{ code: 'BRL', name: 'Brazilian Real' },
	{ code: 'MXN', name: 'Mexican Peso' },
	{ code: 'ARS', name: 'Argentine Peso' },
	{ code: 'CLP', name: 'Chilean Peso' },
	{ code: 'COP', name: 'Colombian Peso' },
	{ code: 'PEN', name: 'Peruvian Sol' },
	{ code: 'UYU', name: 'Uruguayan Peso' },
];

/**
 * Options shaped for `@wordpress/components` SelectControl.
 *
 * @since PBOOKING_SINCE
 *
 * @return {Array<{label:string,value:string}>}
 */
export function getCurrencySelectOptions() {
	return CURRENCIES.map( ( c ) => ( {
		label: `${ c.code } — ${ c.name }`,
		value: c.code,
	} ) );
}
